import Select from 'react-select'
import { useMemo } from 'react'

import { useListProductsQuery } from '../products.service'

const ProductPicker = (props) => {
  const { defaultValue, ...rest } = props
  const { data = {}, isLoading } = useListProductsQuery()
  const computedDefaultValue = useMemo(() => {
    if (defaultValue.value && !defaultValue.label) {
      defaultValue.label = data.results?.find?.((p) => p.id === defaultValue.value)?.name
    }
    return defaultValue
  }, [defaultValue, data.results])

  return (
    <Select
      {...rest}
      defaultValue={computedDefaultValue}
      menuPlacement='auto'
      menuPortalTarget={document.body}
      options={data.results?.map?.((product) => ({
        label: product.name,
        value: product.id
      }))}
      classNamePrefix='react_select'
      isLoading={isLoading}
    />
  )
}

export default ProductPicker
